import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_BATCH_FILES_REQUEST = 'GET_BATCH_FILES_REQUEST';
export const GET_BATCH_FILES_SUCCESS = 'GET_BATCH_FILES_SUCCESS';
export const GET_BATCH_FILES_FAILURE = 'GET_BATCH_FILES_FAILURE';

function requestGetBatchFiles() {
  return {
    type: GET_BATCH_FILES_REQUEST,
    isGettingBatchFiles: true
  };
}

function receiveGetBatchFiles(batchFiles, batchFilesCount) {
  return {
    type: GET_BATCH_FILES_SUCCESS,
    isGettingBatchFiles: false,
    batchFiles,
    batchFilesCount
  };
}

function rejectGetBatchFiles() {
  return {
    type: GET_BATCH_FILES_FAILURE,
    isGettingBatchFiles: false
  };
}

export function getBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters) {
  return (dispatch) => {
    dispatch(requestGetBatchFiles());
    const promise = () => ApiService
      .getBatchFiles(batchId, pageNumber, pageSize, sortBy, sortDirection, filters)
      .then((response) => {
        dispatch(receiveGetBatchFiles(response.data.batchFiles, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetBatchFiles, true));
        }
      });
    return promise();
  };
}
